export { getExtraNavigationTimings, getPageSizeInfo, getPageSizeMetrics } from './page-size';
